import {Box} from 'src/design/atoms/Box';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';

interface FormStaticV2Props {
  field: IFormFieldV2;
}

export const FormParagraphV2 = React.memo<FormStaticV2Props>(
  ({field}: FormStaticV2Props) => {
    return (
      <Box>
        {field.label && <Text>{field.label}</Text>}
        {field.description && (
          <Text c="dimmed" size="sm">
            {field.description}
          </Text>
        )}
      </Box>
    );
  }
);
